import React, { useState } from "react";
import SearchBar from "../components/SearchBar";

export default function NewGroupChatMembers({ contacts, onBack, onNext }) {
  const [selectedIds, setSelectedIds] = useState([]);
  const [search, setSearch] = useState("");

  const toggleContact = (id) => {
    setSelectedIds((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };

  const handleCreate = () => {
    const selectedContacts = contacts.filter((c) => selectedIds.includes(c.id));
    onNext(selectedContacts);
  };

  const filtered = contacts.filter((c) =>
    c.name.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100vh",
        backgroundColor: "#000",
        color: "#fff",
        boxSizing: "border-box",
      }}
    >
      {/* Sticky Header */}
      <div
        style={{
          position: "sticky",
          top: 0,
          zIndex: 10,
          backgroundColor: "#000",
          borderBottom: "1px solid #222",
          padding: "1rem",
          display: "flex",
          alignItems: "center",
        }}
      >
        <button
          onClick={onBack}
          style={{
            color: "#fff",
            background: "none",
            border: "none",
            fontSize: "1.5rem",
            marginRight: "1rem",
            cursor: "pointer",
          }}
        >
          ←
        </button>
        <h2 style={{ margin: 0 }}>Create New Group</h2>
      </div>

      {/* Scrollable Contact List */}
      <div
        style={{
          flex: 1,
          overflowY: "auto",
          padding: "1rem 2rem",
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
        }}
      >
        <SearchBar value={search} onChange={setSearch} />

        {filtered.map((contact) => (
          <label
            key={contact.id}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "1rem",
              padding: "0.75rem 0",
              borderBottom: "1px solid #222",
              cursor: "pointer",
            }}
          >
            <input
              type="checkbox"
              checked={selectedIds.includes(contact.id)}
              onChange={() => toggleContact(contact.id)}
              style={{ accentColor: "#4e8cff" }}
            />
            <img
              src="/images/avatar.png"
              alt="avatar"
              width="48"
              height="48"
              style={{
                borderRadius: "24px",
                objectFit: "cover",
                flexShrink: 0,
              }}
            />
            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: "bold", color: "#4e8cff" }}>{contact.name}</div>
              <div style={{ fontSize: "0.85rem", color: "#aaa" }}>{contact.id}</div>
            </div>
          </label>
        ))}
      </div>

      {/* Footer Button */}
      <div
        style={{
          padding: "1rem 2rem",
          borderTop: "1px solid #222",
          backgroundColor: "#000",
        }}
      >
        <button
          onClick={handleCreate}
          disabled={selectedIds.length === 0}
          style={{
            width: "100%",
            padding: "0.75rem",
            fontSize: "1rem",
            borderRadius: "6px",
            border: "none",
            backgroundColor: selectedIds.length > 0 ? "#4e8cff" : "#333",
            color: "#fff",
            cursor: selectedIds.length > 0 ? "pointer" : "not-allowed",
          }}
        >
          Create Group ({selectedIds.length})
        </button>
      </div>
    </div>
  );
}